export default __webpack_public_path__ + "static/media/coin.0e2a3800.png";